import { getApi } from 'util/api';

export default ({ id, ...params }) => {
  return getApi('/auth/fspaudit', { fspId: id, ...params });
};
